<script>
export default {
  name: "QuickNavigation",
  methods: {
    goHome(val) {
      if(this.$store.state.user.token) return this.$router.push('/login')
      this.$router.push(val)
    }
  }
}
</script>

<template>
  <div class="quick-navigation">
    <div class="q-nav-menus">
      <div class="q-nav-cards-title">快速导航</div>

      <div class="q-nav-menus-main">
        <div class="q-n-m-content">
          <div class="q-n-m-item" @click="$router.push('/homes/home')">首页</div>
          <div class="q-n-m-item" @click="goHome('/curriculums/broadcast')">实时直播</div>
          <div class="q-n-m-item" @click="goHome('/abouts/notice')">公告事项</div>
          <div class="q-n-m-item" @click="goHome('/abouts/common-problem')">常见问题</div>
        </div>
        <div class="q-n-m-content">
          <div class="q-n-m-item" @click="goHome('/abouts/answering-question')">答疑解惑</div>
          <div class="q-n-m-item" @click="goHome('/personal-center/my-question')">我的提问</div>
          <div class="q-n-m-item" @click="goHome('/personal-center/certificate-issuance')">证书颁发</div>
        </div>
      </div>
    </div>

    <div class="q-nav-tel">
      <div class="q-nav-cards-title">联系我们</div>
      <div class="t-m-a-content">
        <div class="app-tel">
          <div class="tel-content">
            <img class="icon" src="@/assets/f-icon/tel.svg">
            <div class="value">0532-89082225 或 89082228</div>
          </div>
        </div>
        <div class="app-address">
          <div class="address-content">
            <img class="icon" src="@/assets/f-icon/address.svg">
            <div class="value">山东省青岛市城阳区流亭重庆北路303号</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">

$QNTHeight: 36px;
$QNTColor: #FFFFFF;


.q-nav-cards-title {
  height: $QNTHeight;
  line-height: 20px;
  color: $QNTColor;
  font-size: 14px;
}

.quick-navigation {
  display: flex;
  justify-content: space-around;
  flex-wrap: nowrap;
  gap: 1em;
}

.q-nav-menus {
  .q-nav-menus-main {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 2em;

    .q-n-m-content {
      .q-n-m-item {
        height: 26px;
        line-height: 26px;
        cursor: pointer;
        font-size: 12px;
        white-space: nowrap;
        text-align: center;

        &:hover {
          color: #FF6700;
        }
      }
    }
  }
}

.q-nav-tel {
  .t-m-a-content {
    .app-tel,
    .app-email,
    .app-address {
      .icon {
        width: 16px;
        height: 16px;
      }

      .tel-content,
      .email-content,
      .address-content {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: nowrap;
        gap: 0.5em;
        margin-bottom: 5px;

        .value {
          font-size: 13px;
          color: #FFFFFF;
        }
      }

      .label {
        font-size: 12px;
        padding-left: calc(16px + 0.5em);
      }
    }

    .app-email,
    .app-address {
      margin-top: 1em;
    }

  }
}


</style>
